<div class="page-head">
  <div>
    <p class="eyebrow">การเบิกจ่าย</p>
    <h1>รายการเบิก</h1>
    <p>ติดตามใบขอเบิก รายการคืนเงิน และสถานะค่าใช้จ่ายจาก Booking, Tour และค่าใช้จ่ายทั่วไป</p>
  </div>
  <button
    type="button"
    class="tw-button inline-flex items-center justify-center gap-2 rounded-xl bg-[var(--theme-color)] px-4 py-2.5 text-sm font-semibold text-white shadow-sm transition hover:bg-[var(--theme-hover)] active:scale-[0.98]"
    (click)="exportExcel()"
  >
    <lucide-icon name="Download" [size]="17" />
    Export Excel
  </button>
</div>

<section class="mt-5 rounded-xl border border-slate-200 bg-white p-4 shadow-sm sm:p-5">
  <div class="mb-4">
    <h2 class="m-0 text-base font-bold text-slate-800">ตัวกรองรายการ</h2>
    <p class="mt-1 mb-0 text-xs text-slate-500">
      เลือกช่วงวันที่ สถานะ ประเภทรายการ ประเภท Booking ประเภทค่าใช้จ่าย และรายการโฮลเซล
    </p>
  </div>

  <div class="grid gap-3 md:grid-cols-2 xl:grid-cols-3">
    <label class="block">
      <span class="mb-1.5 block text-xs font-semibold text-slate-600">วันที่เริ่มต้น</span>
      <p-datepicker
        class="w-full"
        [ngModel]="pendingDateFrom()"
        (ngModelChange)="pendingDateFrom.set($event)"
        dateFormat="dd/mm/yy"
        placeholder="เลือกวันที่เริ่มต้น"
        [showIcon]="true"
        [showClear]="true"
        [readonlyInput]="true"
        appendTo="body"
      />
    </label>
    <label class="block">
      <span class="mb-1.5 block text-xs font-semibold text-slate-600">วันที่สิ้นสุด</span>
      <p-datepicker
        class="w-full"
        [ngModel]="pendingDateTo()"
        (ngModelChange)="pendingDateTo.set($event)"
        dateFormat="dd/mm/yy"
        placeholder="เลือกวันที่สิ้นสุด"
        [showIcon]="true"
        [showClear]="true"
        [readonlyInput]="true"
        appendTo="body"
      />
    </label>
    <label class="block">
      <span class="mb-1.5 block text-xs font-semibold text-slate-600">สถานะใบเบิก</span>
      <p-select
        class="w-full"
        [options]="statusOptions"
        [ngModel]="pendingStatus()"
        (ngModelChange)="pendingStatus.set($event)"
        optionLabel="label"
        optionValue="value"
        placeholder="เลือกสถานะ"
      />
    </label>
    <label class="block">
      <span class="mb-1.5 block text-xs font-semibold text-slate-600">ประเภท Booking</span>
      <p-select
        class="w-full"
        [options]="bookingTypeOptions"
        [ngModel]="pendingBookingType()"
        (ngModelChange)="pendingBookingType.set($event)"
        optionLabel="label"
        optionValue="value"
        placeholder="เลือกประเภท Booking"
      />
    </label>
    <label class="block">
      <span class="mb-1.5 block text-xs font-semibold text-slate-600">ประเภทรายการ</span>
      <p-select
        class="w-full"
        [options]="targetTypeOptions"
        [ngModel]="pendingTargetType()"
        (ngModelChange)="pendingTargetType.set($event)"
        optionLabel="label"
        optionValue="value"
        placeholder="เลือกประเภทใบเบิก"
      />
    </label>
    <label class="block">
      <span class="mb-1.5 block text-xs font-semibold text-slate-600">ประเภทค่าใช้จ่าย</span>
      <p-select
        class="w-full"
        [options]="expenseTypeOptions()"
        [ngModel]="pendingExpenseTypeId()"
        (ngModelChange)="pendingExpenseTypeId.set($event)"
        optionLabel="label"
        optionValue="value"
        placeholder="เลือกประเภทค่าใช้จ่าย"
        [filter]="true"
        filterBy="label"
        appendTo="body"
      />
    </label>
    <label class="block">
      <span class="mb-1.5 block text-xs font-semibold text-slate-600">รายการโฮลเซล</span>
      <p-select
        class="w-full"
        [options]="wholesaleOptions()"
        [ngModel]="pendingWholesaleId()"
        (ngModelChange)="pendingWholesaleId.set($event)"
        optionLabel="label"
        optionValue="value"
        placeholder="เลือกรายการโฮลเซล"
        [filter]="true"
        filterBy="label"
        appendTo="body"
      />
    </label>
  </div>

  <div class="mt-4 flex flex-wrap justify-center gap-2">
    <button
      type="button"
      class="tw-button inline-flex items-center justify-center gap-1.5 rounded-lg bg-[var(--theme-color)] px-5 py-2.5 text-sm font-semibold text-white shadow-sm transition hover:bg-[var(--theme-hover)] active:scale-[0.98]"
      (click)="applyFilters()"
    >
      <lucide-icon name="Search" [size]="16" /> ค้นหา
    </button>
    <button
      type="button"
      class="tw-button inline-flex items-center justify-center gap-1.5 rounded-lg border border-slate-200 bg-white px-4 py-2.5 text-sm font-semibold text-slate-600 hover:bg-slate-50"
      (click)="resetFilters()"
    >
      <lucide-icon name="RotateCcw" [size]="15" /> ล้างค่า
    </button>
  </div>
</section>

<section class="mt-5 overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm">
  <div
    class="flex flex-col gap-4 border-b border-slate-200 px-5 py-4 sm:px-6 lg:flex-row lg:items-end lg:justify-between"
  >
    <div>
      <h2 class="m-0 text-base font-bold text-slate-800">รายการเบิกและคืนเงิน</h2>
      <p class="mt-1 mb-0 text-xs text-slate-500">
        แสดงใบขอเบิกและรายการคืนเงินจาก Booking, Tour และค่าใช้จ่ายทั่วไปตามสิทธิ์ผู้ใช้งาน
      </p>
    </div>
    <div class="flex w-full flex-wrap items-center gap-2 lg:w-auto lg:justify-end">
      <span
        class="rounded-full bg-slate-100 px-2.5 py-1.5 text-[10px] font-semibold text-slate-600"
      >
        {{ filteredItems().length }} รายการ
      </span>
      <label class="relative block w-full sm:w-96">
        <lucide-icon
          name="Search"
          [size]="16"
          class="pointer-events-none absolute top-1/2 left-3 z-10 -translate-y-1/2 text-slate-400"
        />
        <input
          pInputText
          type="search"
          class="h-10 w-full pr-3 text-sm placeholder:text-slate-400"
          style="padding-left: 2.75rem; border-radius: 0.5rem"
          placeholder="ค้นหาเลขใบเบิก เลขคืนเงิน Booking ทัวร์ ลูกค้า รายการ หรือผู้เบิก"
          [ngModel]="searchTerm()"
          (ngModelChange)="searchTerm.set($event)"
        />
      </label>
    </div>
  </div>

  <p-table
    [value]="filteredItems()"
    dataKey="id"
    [paginator]="true"
    [rows]="10"
    [rowsPerPageOptions]="[10, 25, 50]"
    [rowHover]="true"
    [showCurrentPageReport]="true"
    currentPageReportTemplate="แสดง {first} ถึง {last} จาก {totalRecords} รายการ"
    [tableStyle]="{ 'min-width': '1840px' }"
  >
    <ng-template #header>
      <tr>
        <th class="w-14 px-5 py-3 text-center font-semibold whitespace-nowrap">ลำดับ</th>
        <th pSortableColumn="submittedAt" class="min-w-48 px-5 py-3 font-semibold whitespace-nowrap">
          วันที่และเลขที่รายการ <p-sortIcon field="submittedAt" />
        </th>
        <th pSortableColumn="bookingNo" class="min-w-52 px-5 py-3 font-semibold whitespace-nowrap">
          ข้อมูลอ้างอิง <p-sortIcon field="bookingNo" />
        </th>
        <th pSortableColumn="tourCode" class="min-w-64 px-5 py-3 font-semibold whitespace-nowrap">
          รหัสและชื่อทัวร์ <p-sortIcon field="tourCode" />
        </th>
        <th
          pSortableColumn="expenseNameSnapshot"
          class="min-w-72 px-5 py-3 font-semibold whitespace-nowrap"
        >
          ใช้จ่ายและรายละเอียด <p-sortIcon field="expenseNameSnapshot" />
        </th>
        <th
          pSortableColumn="actualTransferAmount"
          class="min-w-48 px-5 py-3 text-right font-semibold whitespace-nowrap"
        >
          ยอดโอนจริง / ยอดประมาณ <p-sortIcon field="actualTransferAmount" />
        </th>
        <th
          pSortableColumn="requestedByName"
          class="min-w-44 px-5 py-3 font-semibold whitespace-nowrap"
        >
          ผู้เบิก <p-sortIcon field="requestedByName" />
        </th>
        <th class="min-w-32 px-5 py-3 text-center font-semibold whitespace-nowrap">เอกสาร</th>
        <th
          pSortableColumn="status"
          class="min-w-40 px-5 py-3 text-center font-semibold whitespace-nowrap"
        >
          สถานะ <p-sortIcon field="status" />
        </th>
        <th class="w-32 px-5 py-3 text-center font-semibold whitespace-nowrap">ดำเนินการ</th>
      </tr>
    </ng-template>

    <ng-template #body let-item let-rowIndex="rowIndex">
      <tr class="transition even:bg-slate-50/40 hover:bg-sky-50/50">
        <td class="px-5 py-3.5 text-[13px] text-slate-400 tabular-nums align-middle">
          <div class="flex w-full items-center justify-center">{{ rowIndex + 1 }}</div>
        </td>
        <td class="px-5 py-3.5 align-top">
          <p class="m-0 text-sm font-semibold whitespace-nowrap text-slate-800">
            {{ item.submittedAt | date: 'dd MMM yyyy' }}
          </p>
          <p class="mt-1 mb-0 text-xs font-medium whitespace-nowrap text-sky-700">
            {{ item.expenseNo }}
          </p>
          <p class="mt-1 mb-0 text-[10px] text-slate-400">
            {{ item.source === 'REFUND' ? 'คืนเงินลูกค้า' : targetTypeLabel(item.targetType) }}
          </p>
        </td>
        <td class="px-5 py-3.5 align-top">
          @if (item.targetType === 'BOOKING' || item.targetType === 'REFUND') {
            <p class="m-0 text-sm font-semibold whitespace-nowrap text-sky-700">
              {{ item.bookingNo }}
            </p>
            <p class="mt-1 mb-0 text-xs text-slate-500">{{ item.customerName }}</p>
            <p class="mt-1 mb-0 text-[10px] text-slate-400">
              {{ bookingTypeLabel(item.bookingType) }}
            </p>
          } @else if (item.targetType === 'TOUR') {
            <p class="m-0 text-sm font-semibold whitespace-nowrap text-sky-700">
              {{ item.tourNo }}
            </p>
            <p class="mt-1 mb-0 text-xs text-slate-500">Tour</p>
          } @else {
            <p class="m-0 text-sm font-semibold text-slate-600">ค่าใช้จ่ายทั่วไป</p>
            <p class="mt-1 mb-0 text-xs text-slate-400">ไม่ผูก Booking หรือ Tour</p>
          }
        </td>
        <td class="px-5 py-3.5 align-top">
          <p class="m-0 text-sm font-semibold text-slate-700">{{ item.tourCode || '—' }}</p>
          <p class="mt-1 mb-0 text-xs text-slate-500">{{ item.tourName }}</p>
          <p class="mt-1 mb-0 text-[10px] text-slate-400">{{ item.country || '—' }}</p>
        </td>
        <td class="px-5 py-3.5 align-top">
          <p class="m-0 text-sm font-medium text-slate-700">{{ item.expenseNameSnapshot }}</p>
          <p class="mt-1 mb-0 text-xs text-slate-500">{{ item.description }}</p>
          @if (item.wholesaleNameSnapshot) {
            <p class="mt-1 mb-0 text-[10px] text-slate-400">
              โฮลเซล {{ item.wholesaleNameSnapshot }}
            </p>
          }
        </td>
        <td class="px-5 py-3.5 text-right align-top tabular-nums">
          <p class="m-0 text-sm font-semibold whitespace-nowrap text-slate-700">
            {{
              item.actualTransferAmount === null
                ? '—'
                : (item.actualTransferAmount | number: '1.2-2')
            }}
          </p>
          <p class="mt-1 mb-0 text-xs whitespace-nowrap text-slate-500">
            ประมาณ {{ item.amount === null ? '—' : (item.amount | number: '1.2-2') }}
          </p>
        </td>
        <td class="px-5 py-3.5 align-top">
          <p class="m-0 text-sm text-slate-700">{{ item.requestedByName }}</p>
          <p class="mt-1 mb-0 text-[10px] text-slate-400">
            อัปเดต {{ item.updatedAt | date: 'dd/MM/yyyy HH:mm' }} น.
          </p>
        </td>
        <td class="px-5 py-3.5 align-top">
          <div class="flex flex-wrap gap-x-3 gap-y-2 text-xs">
            @if (item.attachmentPath) {
              <button
                type="button"
                class="inline-flex items-center gap-1 border-0 bg-transparent p-0 text-xs whitespace-nowrap text-sky-700 no-underline hover:underline"
                [title]="item.source === 'REFUND' ? 'เปิดเอกสารคืนเงิน' : 'เปิดใบสั่งซื้อ'"
                (click)="previewDocument('ใบสั่งซื้อ', item.attachmentPath)"
              >
                <span style="font-weight: 700">{{ item.source === 'REFUND' ? 'เอกสารคืนเงิน' : 'ใบสั่งซื้อ' }}</span>
                <lucide-icon name="ExternalLink" [size]="12" />
              </button>
            }
            @if (item.receiptPath) {
              <button
                type="button"
                class="inline-flex items-center gap-1 border-0 bg-transparent p-0 text-xs whitespace-nowrap text-sky-700 no-underline hover:underline"
                title="เปิดใบเสร็จ"
                (click)="previewDocument('ใบเสร็จ', item.receiptPath)"
              >
                <span style="font-weight: 700">ใบเสร็จ</span>
                <lucide-icon name="ExternalLink" [size]="12" />
              </button>
            }
            @if (item.receiptUrl) {
              <button
                type="button"
                class="inline-flex items-center gap-1 border-0 bg-transparent p-0 text-xs whitespace-nowrap text-sky-700 no-underline hover:underline"
                [title]="item.source === 'REFUND' ? 'เปิดสลิปโอนคืน' : 'เปิดสลิปโอนจ่าย'"
                (click)="previewDocument('สลิปโอนจ่าย', item.receiptUrl)"
              >
                <span style="font-weight: 700">{{ item.source === 'REFUND' ? 'สลิปโอนคืน' : 'สลิปโอนจ่าย' }}</span>
                <lucide-icon name="ExternalLink" [size]="12" />
              </button>
            }
            @if (!item.attachmentPath && !item.receiptPath && !item.receiptUrl) {
              <span class="text-xs text-slate-400">—</span>
            }
          </div>
        </td>
        <td class="px-5 py-3.5 text-center align-middle">
          <app-status-badge
            [status]="item.status"
            [displayLabel]="item.source === 'REFUND' && item.status === 'PAID' ? 'คืนเงินแล้ว' : undefined"
          />
        </td>
        <td class="px-5 py-3.5 align-middle">
          <div class="flex items-center justify-center gap-1.5">
            @if (item.targetType !== 'GENERAL') {
              <button
                type="button"
                class="tw-button inline-flex size-8 items-center justify-center rounded-lg border border-slate-200 bg-white text-slate-600 transition hover:border-sky-200 hover:bg-sky-50 hover:text-sky-700"
                [title]="item.source === 'REFUND' ? 'ดูรายละเอียดการคืนเงิน' : 'ดูรายละเอียดใบเบิก'"
                [attr.aria-label]="item.source === 'REFUND' ? 'ดูรายละเอียดการคืนเงิน' : 'ดูรายละเอียดใบเบิก'"
                (click)="viewExpense(item)"
              >
                <lucide-icon name="Eye" [size]="15" />
              </button>
            }
          </div>
        </td>
      </tr>
    </ng-template>

    <ng-template #emptymessage>
      <tr>
        <td colspan="10" class="px-6 py-14 text-center">
          <lucide-icon name="SearchX" [size]="30" class="mx-auto text-slate-300" />
          <p class="mt-3 mb-0 text-sm font-semibold text-slate-600">ไม่พบรายการเบิกหรือคืนเงิน</p>
          <p class="mt-1 mb-0 text-xs text-slate-400">ลองปรับช่วงวันที่ สถานะ หรือคำค้นหาใหม่</p>
        </td>
      </tr>
    </ng-template>
  </p-table>
</section>
